import { banks } from "./constants";

export const bankSearchParam = [
  banks.caixa.value,
  banks.santander.value,
  banks.bradesco.value,
] as const;

export const modalitySearchParam = ["1", "2", "3", "4"] as const;

export const sortingSearchParam = [
  "dataDoLeilao",
  "dataDeInclusao",
  "menorPreco",
  "maiorPreco",
  "maiorDesconto",
] as const;

export const typeSearchParam = [
  "todos",
  "casa",
  "apartamento",
  "terreno",
  "sala",
  "comercial",
  "galpão",
  "loja",
  "predio",
  "lote",
  "gleba",
] as const;

export const paymentSearchParam = [
  "fgts",
  "financiamento",
  "parcelamento",
  "consorcio",
] as const;

export const filterSearchParam = {
  cidade: "cidade",
  ordenar: "ordenar",
  tipo: "tipo",
  pagamento: "pagamento",
  modalidade: "modalidade",
  banco: "banco",
  precoMax: "precoMax",
  precoMin: "precoMin",
  tamanhoPropriedade: "tamanhoPropriedade",
  tamanhoArea: "tamanhoArea",
  pesquisa: "pesquisa",
  pagina: "pagina",
} as const;

export const propertyTabSearchParam = {
  campo: "campo",
  aba: "aba",
  secao: "secao",
} as const;

export const pricingSearchParam = {
  plano: "plano",
  periodo: "periodo",
  cupom: "cupom",
} as const;
